import { Link } from 'react-router-dom';

interface BreadcrumbItem {
  label: string;
  to?: string;
}

export default function Breadcrumb({ items }: { items: BreadcrumbItem[] }) {
  return (
    <nav aria-label="面包屑导航" className="flex items-center gap-1.5 text-sm text-foreground-500">
      {items.map((item, i) => (
        <span key={i} className="flex items-center gap-1.5">
          {i > 0 && (
            <i className="ri-arrow-right-s-line text-foreground-300 text-xs"></i>
          )}
          {item.to ? (
            <Link
              to={item.to}
              className="hover:text-primary-600 transition-colors"
            >
              {item.label}
            </Link>
          ) : (
            <span className="text-foreground-700 font-medium">{item.label}</span>
          )}
        </span>
      ))}
    </nav>
  );
}